// Resolves which of the shared calendarEventStore.animals / .visitors entries
// belong to the calendar event actually being displayed. Pure function — no
// stores, no JSX, returns new arrays and never mutates the inputs.
//
// The store keys `calendarEvent`, `animals` and `visitors` are shared
// app-wide: calendar day/week range loads, the frontpage dashboard poll and
// every other event drawer write to the same keys. By the time the user
// clicks a button in the event drawer, the arrays may hold a DIFFERENT
// event's data (TICKET-01282: clicking "Dina - Klara" in the calendar opened
// the profile of "Aico - Mette" from the previous day's appointment).
// Filtering against the displayed event's own animals[].id restores the
// invariant that what the drawer shows and forwards matches that event.
// Guard every input with Array.isArray, not `|| []`. The shared observables can
// hold a truthy NON-array transiently — e.g. chooseAnimal() optimistically wrote
// a single animal object into calendarEvent.animals (an array field), which made
// the render crash with "(... || []).map is not a function" (error.id 86681).
// `|| []` only catches falsy values; a stray object/number/string sails through.
const asArray = value => (Array.isArray(value) ? value : []);

export function getEventAnimalsAndVisitors(calendarEvent, animals, visitors) {
    const eventAnimalIds = asArray(calendarEvent?.animals)
        .map(a => a?.id)
        .filter(id => id > 0);
    const eventAnimals = asArray(animals).filter(a => eventAnimalIds.includes(a?.id));
    const ownerIds = eventAnimals
        .map(a => a?.owner)
        .filter(id => id > 0);
    const eventVisitors = asArray(visitors).filter(v => v?.id > 0 && ownerIds.includes(v.id));
    return { eventAnimals, eventVisitors };
}
